export default "__VITE_ASSET__ce3c61aa__"